

























































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import ClientJson, { defaultClientJson } from "../../shared/ClientJson";
import { ClientStatus } from "../../shared/ClientStatus";
import { AccountStatus } from "../../shared/AccountStatus";
import RentalAccountJson from "../../shared/RentalAccountJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "RentalAccountSelect",
  components: {
    OverlayWindow,
    PointerMenu,
    Loading,
    TableView,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      detailsTitle: "Account auswählen",
      UserPermissionRank: UserPermissionRank,
      searchString: null as string | null,
      allClients: null as ClientJson[] | null,
      clientsMoreAvailable: null as boolean | null,
      hasChanges: false,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initView();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initView() {
      this.loadAllClients();
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadAllClients(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.allClients = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      var typeIds = null;
      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.allClients != null) {
        this.clientsMoreAvailable = null;
        skipAmount = this.allClients.length;
      } else {
        this.allClients = null;
      }

      if (this.restClient != null) {
        try {
          let clients = await this.restClient.getClients(typeIds, false, true, false, this.searchString, skipAmount);

          if (loadMore && this.allClients != null) {
            this.allClients = this.allClients.concat(clients.clients);
          } else {
            this.allClients = clients.clients;
          }

          this.clientsMoreAvailable = clients.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    /* async loadAllAccounts() {
      if (this.restClient != null) {
        try {
          this.allAccounts = await this.restClient.getRentalAccounts();
        } catch (e) {
          alert(e.message);
        }
      }
    }, */

    //START set cached data

    //END set cached data

    selectAccount(item: RentalAccountJson) {
      this.$emit("change", item);
      this.closeDetails();
    },

    closeDetails() {
      this.$emit("closeOverlay");
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "selectAccount") {
        this.selectAccount(item);
      }
    },

    tableViewItemClicked(item: any) {
      this.selectAccount(item);
    },
  },

  watch: {},

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    clientColumns: function (): TableViewColumnDefinitions<ClientJson>[] {
      let vue = this;

      return [
        {
          th: "Vorname",
          td: (i) => (i.contact?.firstName != "" ? i.contact?.firstName : "--"),
        },
        {
          th: "Nachname",
          td: (i) => (i.contact?.lastName != "" ? i.contact?.lastName : "--"),
        },
        {
          th: "E-Mail",
          td: (i) => (i.contact?.email != "" ? i.contact?.email : "--"),
        },
        {
          th: "Art",
          td: (i) => i.rentalTypes.join(", "),
        },
        {
          th: "",
          td: (i) => "Auswählen",
          style: (i) => "text-align:right",
          button: "selectAccount",
        },
      ] as TableViewColumnDefinitions<ClientJson>[];
    },

    filteredClients(): ClientJson[] | undefined {
      if (this.allClients != null) {
        return this.allClients.filter(
          (i: ClientJson) => i.state == ClientStatus.active && i.accountState == AccountStatus.active
        );
      }
    },
  },
});
